<h2 class="default-dialog-header" mat-dialog-title>{{data.isEdit ? 'Edit' : 'Add'}} Contact</h2>
<mat-divider></mat-divider>

<form [formGroup]="addContact">
	<mat-dialog-content class="default-dialog-content">
		<div class="m-t-1" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
			<mat-form-field fxFlex="100">
				<input formControlName="firstName" matInput placeholder="First Name" />
			</mat-form-field>
		</div>

		<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
			<mat-form-field fxFlex="100">
				<input formControlName="lastName" matInput placeholder="Last Name" />
			</mat-form-field>
		</div>

		<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
			<mat-form-field fxFlex="100">
				<input formControlName="email" matInput placeholder="Email" />
			</mat-form-field>
		</div>

		<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
			<div fxFlex>
				<mat-form-field fxFlex="100">
					<input
						[showMaskTyped]="true"
						formControlName="phoneNumber"
						mask="(000) 000-0000"
						matInput
						placeholder="Office Number"
					/>
				</mat-form-field>
			</div>
			<div fxFlex>
				<mat-form-field fxFlex="100">
					<input formControlName="ext" matInput placeholder="ext." />
				</mat-form-field>
			</div>
		</div>

		<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
			<mat-form-field fxFlex="100">
				<input formControlName="mobileNumber" matInput placeholder="Mobile Number" />
			</mat-form-field>
		</div>

		<div
			fxLayout="row"
			fxLayoutAlign="start center"
			fxLayoutGap="1rem"
		>
			<div fxFlex>
				<mat-slide-toggle color="primary" formControlName="accountCarrierContact">
					Is Email Recipient
				</mat-slide-toggle>
			</div>

			<div *ngIf="utilService.isAccountTypeAdmin()" fxFlex>
				<mat-slide-toggle color="primary" formControlName="primaryContact">
					Is Primary Contact
				</mat-slide-toggle>
			</div>

			<div *ngIf="utilService.isAccountTypeAdmin()" fxFlex>
				<mat-slide-toggle color="primary" formControlName="vettingAuthorizedOverride">
					Vetting Authorized Override
				</mat-slide-toggle>
			</div>
		</div>

		<div
			*ngIf="utilService.isAccountTypeAdmin() && data.isEdit"
			fxLayout="row"
			fxLayoutAlign="center center"
			fxLayoutGap="1rem"
			class="m-t-1"
		>
			<div fxFlex fxLayoutAlign="start center">
				<mat-slide-toggle color="primary" formControlName="hideName"> Hide name </mat-slide-toggle>
				<mat-icon
					class="primary-light-color"
					matTooltip="If enabled, the contact's name will be shown as 'Dispatch' in outgoing emails and in app. This setting applies to validated contacts and cannot be manually updated, as changes will be overridden by the contact validation process."
					matTooltipClass="cc_mat_tooltip"
				>
					info
				</mat-icon>
			</div>

			<div fxFlex fxLayoutAlign="start center">
				<mat-slide-toggle color="primary" formControlName="hidePhone">
					Hide phone number
				</mat-slide-toggle>
				<mat-icon
					class="primary-light-color"
					matTooltip="If enabled, phone number will be hidden and excluded from emails. This setting applies to validated contacts and cannot be manually updated, as changes will be overridden by the contact validation process."
					matTooltipClass="cc_mat_tooltip"
				>
					info
				</mat-icon>
			</div>
		</div>
	</mat-dialog-content>

	<mat-divider></mat-divider>

	<mat-dialog-actions class="default-dialog-action">
		<div fxFlex="100" fxLayoutAlign="end end">
			<a (click)="closeDialog()" mat-button><span class="primary-text">Cancel</span></a>
			<button
				(click)="onSubmit()"
				*ngIf="!isRequestInProgress"
				[disabled]="addContact.invalid"
				color="primary"
				mat-raised-button
			>
				{{data.isEdit ? 'Edit' : 'Create'}} Contact
			</button>
			<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
		</div>
	</mat-dialog-actions>
</form>
